<template>
    <div>
        <compra-direta-ferramenta-de-busca v-model="filtrosBuscaAvancada"
                                           :situacoesPossiveis="situacoesPossiveisFornecedor"
                                           :placeholderPesquisa="placeholderPesquisa"
                                           :filtros="filtrosInterno"
                                           @eventoBuscaSimples="tratarEventoBuscaSimples"
                                           @eventoRemoverFiltro="tratarEventoRemoverFiltro"
                                           @eventoBuscaAvancada="processarEventoBuscarAvancada"
                                           @updateSituacoes="(situacoes) => filtrosBuscaAvancada.situacoes = situacoes">
        </compra-direta-ferramenta-de-busca>

        <minhas-compras-diretas-tabela v-if="exibirTabela"
                                       :itens="itens"
                                       :paginas="paginas"
                                       :total-itens="totalItens"
                                       :paginacao="$store.state.fornecedor.resultadoBuscaMinhasComprasDiretas.paginacao"
                                       @acessarPncp="acessarPncp"
                                       @paginar="tratarEventoPaginar"
                                       @acessar="tratarEventoAcessar"/>

        <minhas-compras-diretas-frase v-else
                                      @irParaComprasAbertas="redirecionarParaComprasAbertas"/>
    </div>
</template>

<script>
import _ from 'lodash'
import {actionTypes, mutationTypes} from '@/core/constants'
import MinhasComprasDiretasTabela from './MinhasComprasDiretasTabela'
import MinhasComprasDiretasFrase from './MinhasComprasDiretasFrase'
import CompraDiretaFerramentaDeBusca from '@/views/pages/commons/busca-avancada/CompraDiretaFerramentaDeBusca'

export default {
    name: 'MinhasComprasDiretas',
    components: {
        CompraDiretaFerramentaDeBusca,
        MinhasComprasDiretasFrase,
        MinhasComprasDiretasTabela
    },
    data() {
        return {
            totalItens: 0,
            paginas: 0,
            filtrosInterno: this.getFiltrosMinhasComprasDiretas(),
            filtrosBuscaAvancada: this.getFiltrosBuscaAvancadaFornecedor(),
            itens: [],
            ehBuscaAvancada: false
        }
    },
    computed: {
        exibirTabela() {
            return (this.itens && (this.itens.length > 0 || this.filtrosInterno.conteudo))
        },
        placeholderPesquisa() {
            const texto = this.$t('main.fornecedor_minhas_compras_diretas_orgao.text').toLowerCase()
            return `Busque por: nº processo, nº consulta, objeto ou ${texto}`
        },
        situacoesPossiveisFornecedor(){
            const situacoesPossiveis = { ...this.situacoesCompraDireta }

            delete situacoesPossiveis['EM_ELABORACAO']

            return situacoesPossiveis
        }
    },
    async mounted() {
        try {
            await this.buscar()
        } catch (e) {
            this.mostrarNotificacaoErro(e.message)
        }
    },
    methods: {
        async buscar() {
            this.$store.commit(mutationTypes.FORNECEDOR.SET_FILTROS_BUSCA_MINHAS_COMPRAS_DIRETAS, this.getFiltrosInterno())
            this.setMensagemLoading('Carregando compras diretas...')
            const resultado = await this.$store.dispatch(actionTypes.FORNECEDOR.BUSCAR_MINHAS_COMPRAS_DIRETAS)
            this.itens = resultado.itemList
            this.paginas = resultado.totalPages
            this.totalItens = resultado.totalElements

            this.resetFiltroBuscaAvancadaFornecedor()
        },
        tratarEventoAcessar(id) {
            this.$store.commit(mutationTypes.SET_ROTA_ORIGEM, 'MinhasComprasDiretas')
            this.$router.push({name: 'DetalhesCompraDireta', params: {id}})
        },
        tratarEventoRemoverFiltro(propriedade) {
            if (this.filtrosInterno && this.filtrosInterno.hasOwnProperty(propriedade)) {
                this.filtrosInterno[propriedade].value = this.filtrosInterno[propriedade].default
            }
            this.filtrosInterno.conteudo = ''
            this.resetFiltroBuscaAvancadaFornecedor()
            this.filtrosBuscaAvancada = this.getFiltrosBuscaAvancadaFornecedor()
            this.buscar()
        },
        tratarEventoBuscaSimples(valor) {
            if (valor) {
                this.filtrosInterno.objeto.value = valor
                this.filtrosInterno.conteudo = valor
                this.buscar()
            }
        },
        tratarEventoPaginar(paginacao) {
            if(this.ehBuscaAvancada){
                this.$store.commit(mutationTypes.FORNECEDOR.SET_PAGINACAO_BUSCA_AVANCADA_COMPRAS_DIRETAS_FORNECEDOR, paginacao)
                this.processarEventoBuscarAvancada()
            }
            else {
                this.$store.commit(mutationTypes.FORNECEDOR.SET_PAGINACAO_BUSCA_MINHAS_COMPRAS_DIRETAS, paginacao)
                this.buscar()
            }
        },
        redirecionarParaComprasAbertas() {
            this.$router.push({name: 'ComprasDiretasAbertas'})
        },
        getFiltrosMinhasComprasDiretas() {
            return _.cloneDeep(this.$store.state.fornecedor.resultadoBuscaMinhasComprasDiretas.filtros)
        },
        getFiltrosInterno() {
            return _.cloneDeep(this.filtrosInterno)
        },
        async acessarPncp({cnpjOrgaoSuperiorPncp, ano, sequencialCompraPublica, urlFrontendPncp}) {
            await this.$store.dispatch(actionTypes.EXIBIR_NO_PNCP, {cnpjOrgaoSuperiorPncp, ano, sequencialCompraPublica, urlFrontendPncp})
        },
        getFiltrosBuscaAvancadaFornecedor() {
            return _.cloneDeep(this.$store.state.fornecedor.resultadoBuscaAvancadaComprasDiretasFornecedor.filtros)
        },
        resetFiltroBuscaAvancadaFornecedor(){
            this.ehBuscaAvancada = false
            this.$store.state.fornecedor.resultadoBuscaAvancadaComprasDiretasFornecedor.reset()

            /**
             * TODO Refatorar o funcionamento da busca avançada para se usar o esquema da busca simples
             *  e depois remove essas linhas abaixo, e também o atributo ehBuscaAvancada
             */

            const paginacaoInicial = {
                page: 1,
                rowsPerPage: 10,
                descending: true,
                sortBy: 'dataHoraEncerramento'
            }
            this.$store.commit(mutationTypes.FORNECEDOR.SET_PAGINACAO_BUSCA_MINHAS_COMPRAS_DIRETAS, paginacaoInicial)
            this.$store.commit(mutationTypes.FORNECEDOR.SET_PAGINACAO_BUSCA_AVANCADA_COMPRAS_DIRETAS_FORNECEDOR, paginacaoInicial)
        },
        async processarEventoBuscarAvancada() {
            this.$store.commit(mutationTypes.FORNECEDOR.SET_FILTROS_BUSCA_AVANCADA_COMPRAS_DIRETAS_FORNECEDOR, this.filtrosBuscaAvancada)
            this.setMensagemLoading('Carregando compras diretas...')
            const resultado = await this.$store.dispatch(actionTypes.FORNECEDOR.BUSCAR_AVANCADA_COMPRAS_DIRETAS_FORNECEDOR)
            this.itens = resultado.itemList
            this.paginas = resultado.totalPages
            this.totalItens = resultado.totalElements

            this.ehBuscaAvancada = true
        },
    }
}
</script>

<style scoped>

</style>
